<!-- Header moved inside main container -->

<div class="row justify-content-center mb-5">
    <div class="col-12 col-xl-8">
        <!-- New Header Layout -->
        <div class="mb-4 position-relative">
            <div class="d-flex justify-content-center align-items-center mb-2 position-relative">
                <button (click)="cancel()"
                    class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2 position-absolute start-0 top-0">
                    <span class="material-symbols-outlined" style="font-size: 18px;">arrow_back</span>
                </button>
                <div class="d-flex align-items-center gap-2">
                    <span class="material-symbols-outlined fs-4">shield</span>
                    <h1 class="h4 mb-0">{{ readOnly ? 'Ver' : isEditMode ? 'Editar' : 'Nuevo' }} <strong
                            class="fw-semibold text-colonial">Producto</strong></h1>
                </div>
            </div>
            <p class="text-muted text-center mx-auto mb-0" style="max-width: 520px;">
                {{ readOnly ? 'Consulta los datos del producto.' : isEditMode ? 'Modifica los datos del producto.' :
                'Completa los datos para crear un nuevo producto.' }}
            </p>
        </div>

        <!-- A bank's only lever on a Colonial product: offer it or not, for their bank -->
        <div *ngIf="showBankVisibilityToggle" class="card shadow-sm border-0 overflow-hidden rounded-4 mb-4">
            <div class="card-body d-flex align-items-center justify-content-between gap-3">
                <div>
                    <div class="fw-bold d-flex align-items-center gap-2">
                        <span class="material-symbols-outlined text-colonial">storefront</span>
                        Mostrar este producto para tu banco
                    </div>
                    <small class="text-muted">Este producto de La Colonial no puede editarse, pero puedes decidir si
                        se ofrece en la aplicación de clientes para tu banco.</small>
                </div>
                <div class="form-check form-switch fs-5 mb-0">
                    <input class="form-check-input" type="checkbox" id="bankVisibleToggle" [checked]="bankVisible"
                        [disabled]="savingBankVisibility" (change)="toggleBankVisibility($event)" />
                </div>
            </div>
        </div>

        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">edit_note</span>
                    <span>Formulario</span>
                </h3>
            </div>
            <div class="card-body">
                <form (ngSubmit)="onSubmit()" [formGroup]="form" [class.form-readonly]="readOnly">
                    <!-- Native fieldset disabling covers every nested input and button,
                         including the custom selectors; the CSS guard blocks the rest. -->
                    <fieldset [disabled]="readOnly" class="readonly-scope border-0 p-0 m-0">
                    <div class="row g-3">
                        <!-- General Options Row (At the top as requested) -->
                        <div class="col-12 py-2 border-bottom mb-2">
                            <div class="row align-items-center">
                                <div class="col-12 col-md-6">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" formControlName="familyAllowed"
                                            id="familyAllowed" type="checkbox" />
                                        <label class="form-check-label fw-bold" for="familyAllowed">¿Permite
                                            familia?</label>
                                        <span class="text-muted small ms-2 d-none d-lg-inline">(Configuración de
                                            hijos)</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 text-md-end mt-2 mt-md-0">
                                    <div class="form-check form-switch d-md-inline-block">
                                        <input class="form-check-input" formControlName="requiresOccupation"
                                            id="requiresOccupation" type="checkbox" />
                                        <label class="form-check-label fw-bold" for="requiresOccupation">¿Requiere
                                            ocupación?</label>
                                    </div>
                                </div>
                                <div class="col-12 mt-2">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" formControlName="visible" id="productVisible"
                                            type="checkbox" />
                                        <label class="form-check-label fw-bold" for="productVisible">Visible en la
                                            aplicación de clientes</label>
                                        <span class="text-muted small ms-2 d-none d-lg-inline">(Si está apagado, el
                                            producto no se ofrece)</span>
                                    </div>
                                </div>
                                <div class="col-12 mt-2">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" formControlName="allowBeneficiaries"
                                            id="allowBeneficiaries" type="checkbox" />
                                        <label class="form-check-label fw-bold" for="allowBeneficiaries">¿Requiere
                                            beneficiarios?</label>
                                        <span class="text-muted small ms-2 d-none d-lg-inline">(El cliente registra
                                            beneficiarios, parentesco y porcentajes al pagar)</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Child Configuration (Conditional) -->
                        <div *ngIf="form.get('familyAllowed')?.value" class="col-12">
                            <div class="alert alert-light border shadow-sm p-3 mb-0">
                                <h6
                                    class="text-colonial fw-bold text-uppercase small mb-3 d-flex align-items-center gap-2">
                                    <span class="material-symbols-outlined fs-6">family_restroom</span>
                                    Configuración de Hijos
                                </h6>
                                <div class="row g-3">
                                    <div class="col-12 col-md-4">
                                        <label class="form-label small fw-semibold">Edad Mínima (Hijos) *</label>
                                        <input class="form-control form-control-sm" formControlName="childMinAge"
                                            mask="0*" sharedFormInput type="text" />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <label class="form-label small fw-semibold">Edad Máx. Entrada (Hijos) *</label>
                                        <input class="form-control form-control-sm" formControlName="childMaxAge"
                                            mask="0*" sharedFormInput type="text" />
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <label class="form-label small fw-semibold">Edad Máx. Permanencia (Hijos)
                                            *</label>
                                        <input class="form-control form-control-sm"
                                            formControlName="childMaxDurationAge" mask="0*" sharedFormInput
                                            type="text" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Name -->
                        <div class="col-12 col-md-6">
                            <label class="form-label">Nombre *</label>
                            <input class="form-control" formControlName="name" sharedFormInput type="text" />
                        </div>

                        <!-- Category -->
                        <div class="col-12 col-md-6">
                            <label class="form-label">Categoría *</label>
                            <select class="form-select" formControlName="category" sharedFormInput>
                                <option *ngFor="let opt of categoryOptions" [ngValue]="opt.value">{{ opt.label }}
                                </option>
                            </select>
                        </div>

                        <!-- Bank Selector (SuperUser/Supervisor only) -->
                        <div *ngIf="showBankSelector" class="col-12 col-md-6">
                            <label class="form-label">Banco {{ isSupervisor ? '*' : '' }}</label>
                            <select class="form-select" formControlName="bankId" sharedFormInput>
                                <option *ngIf="isSuperUser" [ngValue]="null">Sin banco (todos)</option>
                                <option *ngFor="let bank of banks" [ngValue]="bank.id">{{ bank.name }}</option>
                            </select>
                        </div>

                        <!-- LOB -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">LOB *</label>
                            <input class="form-control" formControlName="lob" mask="0*" sharedFormInput type="text" />
                        </div>

                        <!-- SLOB -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">SLOB *</label>
                            <input class="form-control" formControlName="slob" mask="0*" sharedFormInput type="text" />
                        </div>

                        <!-- PlanCode (core) -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Código de plan (core)</label>
                            <input class="form-control" formControlName="planCode" mask="0*" type="text"
                                placeholder="Opcional" />
                        </div>

                        <!-- FormulaId -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Formula ID *</label>
                            <select class="form-select" formControlName="formulaId" sharedFormInput>
                                <option *ngFor="let opt of formulaOptions" [value]="opt.value">{{ opt.label }}</option>
                            </select>
                        </div>

                        <!-- Min Age -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Edad Mínima *</label>
                            <input class="form-control" formControlName="minAge" mask="0*" sharedFormInput
                                type="text" />
                        </div>

                        <!-- Max Age -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Edad Máx. Entrada*</label>
                            <input class="form-control" formControlName="maxAge" mask="0*" sharedFormInput
                                type="text" />
                        </div>

                        <!-- Max Duration Age -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Edad Máx. Duración*</label>
                            <input class="form-control" formControlName="maxDurationAge" mask="0*" sharedFormInput
                                type="text" />
                        </div>

                        <!-- Duration Min -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Duración Mín. (años)</label>
                            <input class="form-control" formControlName="durationMin" mask="0*" type="text" />
                        </div>

                        <!-- Duration Max -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Duración Máx. (años)</label>
                            <input class="form-control" formControlName="durationMax" mask="0*" type="text" />
                        </div>

                        <!-- Icon -->
                        <div class="col-12 col-md-3">
                            <label class="form-label">Icono</label>
                            <input class="form-control" formControlName="icon" type="text" />
                        </div>

                        <!-- Description -->
                        <div class="col-12">
                            <label class="form-label">Descripción</label>
                            <textarea class="form-control" formControlName="description" rows="3"></textarea>
                        </div>

                        <!-- Benefits -->
                        <div class="col-12">
                            <label class="form-label">Beneficios</label>
                            <app-benefits-list formControlName="benefits"></app-benefits-list>
                        </div>





                        <!-- Suma asegurada y Preguntas (Inside Form) -->
                        @if (!isEnfermedadesGraves && !isRespaldoColonial && !isUltimosGastos) {
                        <div class="col-12 col-md-6">
                            <label class="form-label fw-bold">Límites Generales</label>
                            <app-currency-selector formControlName="currencyIds"></app-currency-selector>
                        </div>
                        }

                        @if (selectedCurrencies.length > 0) {
                        <div class="col-12">
                            <label class="form-label fw-bold mb-1">Prima mínima de la póliza (sin impuestos)</label>
                            <div class="form-text mt-0 mb-2">Si la prima neta anual calculada es menor, se cobra este
                                mínimo. Déjelo vacío para no aplicar mínimo.</div>
                            <div class="d-flex flex-wrap gap-2">
                                @for (currency of selectedCurrencies; track currency.id) {
                                <div class="input-group input-group-sm" style="max-width: 240px">
                                    <span class="input-group-text">{{ currency.currency }}</span>
                                    <input type="text" class="form-control"
                                        [ngModel]="currencyMinPremiums[currency.id]"
                                        [ngModelOptions]="{ standalone: true }"
                                        (ngModelChange)="updateCurrencyMinPremium(currency.id, $event)"
                                        mask="separator.2" thousandSeparator="," placeholder="Sin mínimo">
                                </div>
                                }
                            </div>
                        </div>
                        }

                        @if (!isEnfermedadesGraves && !isRespaldoColonial && !isUltimosGastos) {
                        <div class="col-12">
                            <label class="form-label fw-bold mb-1">Suma asegurada máxima por edad</label>
                            <app-age-amount-limit-selector formControlName="ageAmountLimits"></app-age-amount-limit-selector>
                        </div>
                        }

                        <div class="col-12 col-md-6">
                            <label class="form-label fw-bold">Grupos de Preguntas</label>
                            <app-question-group-selector
                                formControlName="questionGroupIds"></app-question-group-selector>
                        </div>
                    </div>

                    <!-- Planes de Enfermedades Graves (Now inside form) -->
                    @if (isEnfermedadesGraves) {
                    <div class="mt-4 pt-3 border-top">
                        <h5 class="fw-bold mb-3 text-dark">Planes de Enfermedades Graves</h5>
                        <app-serious-illness-plan-selector
                            formControlName="seriousIllnessPlans"></app-serious-illness-plan-selector>
                    </div>
                    }

                    <!-- Tarifas por Edades Seguro Médico Catastrófico -->
                    @if (isSeguroMedicoCatastrofico) {
                    <div class="mt-4 pt-3 border-top">
                        <app-catastrophic-medical-age-pricing-selector [allowsFamily]="form.get('familyAllowed')?.value"
                            [currencies]="selectedCurrencies" formControlName="catastrophicMedicalAgePricings">
                        </app-catastrophic-medical-age-pricing-selector>
                    </div>
                    }

                    <!-- Planes de Respaldo Colonial y Últimos Gastos -->
                    @if (isRespaldoColonial || isUltimosGastos) {
                    <div class="mt-4 pt-3 border-top">
                        <h5 class="fw-bold mb-3 text-dark">
                            Planes de {{ isUltimosGastos ? 'Últimos Gastos' : 'Respaldo Colonial' }}
                        </h5>
                        <app-coverage-plan-selector formControlName="coveragePlans"
                            [planType]="isUltimosGastos ? 'Últimos Gastos' : 'Respaldo Colonial'"></app-coverage-plan-selector>
                    </div>
                    }


                    <!-- Coberturas (Now inside form) -->
                    @if (!isEnfermedadesGraves && !isRespaldoColonial && !isUltimosGastos) {
                    <div class="mt-4 pt-3 border-top">
                        <h5 class="fw-bold mb-3">Coberturas</h5>
                        <app-coverage-selector [defaultMaxAge]="(maxAge$ | async) ?? 100"
                            [defaultMaxDurationAge]="(maxDurationAge$ | async) ?? 0"
                            [selectedCurrencyIds]="currentCurrencyIds" [formulaId]="form.get('formulaId')?.value"
                            formControlName="coverages">
                        </app-coverage-selector>
                    </div>
                    }

                    <!-- Requirement Bands (Now inside form) -->
                    <div class="mt-4 pt-3 border-top">
                        <h5 class="fw-bold mb-3">Requisitos de Asegurabilidad</h5>
                        <app-requirement-band-selector
                            formControlName="requirementBands"></app-requirement-band-selector>
                    </div>

                    <!-- Role-based info -->
                    <div *ngIf="isSupervisor" class="mt-4">
                        <div class="alert alert-secondary border-0 shadow-sm d-flex align-items-center gap-2">
                            <span class="material-symbols-outlined">info</span>
                            <small class="fw-medium">El producto se asociará al banco que selecciones.</small>
                        </div>
                    </div>

                    </fieldset>

                    <!-- Actions -->
                    <div class="d-flex justify-content-end gap-2 mt-5 pt-3 border-top">
                        <button (click)="cancel()" class="btn btn-light px-4 py-2 fw-semibold"
                            type="button">{{ readOnly ? 'Volver' : 'Cancelar' }}</button>
                        <button *ngIf="!readOnly" class="btn btn-colonial px-5 py-2 fw-bold shadow-sm" type="submit">
                            {{ isEditMode ? 'Actualizar Producto' : 'Crear Producto' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>